import { createMedia } from "@artsy/fresnel";
import { deviceBreakpoints as breakpoints } from "packages/dsaui/src/theme";

const ResponsiveMedia = createMedia({ breakpoints });
const { createMediaStyle } = ResponsiveMedia;

export const mediaStyles = createMediaStyle();

export const { MediaContextProvider, Media } = ResponsiveMedia;
